/**
 * - react-naver-login + 네이버 SDK: #naverIdLogin 숨김 영역(img alt 없음, a[href="#"]).
 * - Google Sign-In(gapi / react-google-login): accounts.google.com OAuth iframe에 title 없음.
 * 실제 조작은 화면 버튼이므로 DOM만 보정한다.
 */
let observer: MutationObserver | null = null;

const GOOGLE_OAUTH_IFRAME_TITLE = '구글 계정 로그인';

function patchGoogleOAuthIframes(): void {
  document.querySelectorAll('iframe[src*="accounts.google.com"]').forEach((el) => {
    const iframe = el as HTMLIFrameElement;
    const t = iframe.getAttribute('title');
    if (t == null || !String(t).trim()) {
      iframe.setAttribute('title', GOOGLE_OAUTH_IFRAME_TITLE);
    }
  });
}

function patchNaverHiddenLoginDom(): void {
  const root = document.getElementById('naverIdLogin');
  if (!root?.firstChild) return;

  root.setAttribute('aria-hidden', 'true');

  root.querySelectorAll('img').forEach((img) => {
    if (!img.hasAttribute('alt') || img.getAttribute('alt') === null) {
      img.setAttribute('alt', '네이버 로그인');
    }
  });

  root.querySelectorAll('a').forEach((link) => {
    const h = link.getAttribute('href');
    if (h === '#' || h === '') {
      link.removeAttribute('href');
      if (!link.getAttribute('role')) {
        link.setAttribute('role', 'button');
      }
    }
  });
}

export function startNaverHiddenLoginA11yObserver(): void {
  if (typeof document === 'undefined' || observer) return;

  const run = () => {
    patchNaverHiddenLoginDom();
    patchGoogleOAuthIframes();
  };
  observer = new MutationObserver(run);
  observer.observe(document.body, {childList: true, subtree: true});
  run();
}
